import Navbar from "../components/Navbar";
import Services from "../components/Services";
import Hero from "../components/Hero";
import About from "../components/About";
import Projects from "../components/Project";
import Testimonial from "../components/Testimonial";
import Footer from "../components/Footer";
// import ScrollToTop from "../components/Scrolltoup";
import Chatbot from "./Chatbot";

export default function LandingPage() {

  return (
    <div className="font-sans bg-white text-gray-900 scroll-smooth">

     {/* NAVBAR */}
    <Navbar/>
    {/* Hero */}
     <Hero/>
      {/* SERVICES */}
   <Services/>
  <About/>
   <Projects/>
  <Testimonial/>
      {/* FOOTER */}
    
      <Footer/>
      {/* <ScrollToTop/> */}
      <Chatbot/>
    </div>
  );
}